
import { useState, useEffect, useCallback } from 'react';

export function useScrollPosition(threshold = 10): boolean {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
    setIsScrolled(scrollY > threshold);
  }, [threshold]);

  useEffect(() => {
    // Initial check
    handleScroll();
    
    // Add scroll listener with passive flag for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return isScrolled;
}
